import {
    Assets,
    Sprite,
    Graphics,
    Text,
    Container,
} from 'pixi.js';
import {sound} from '@pixi/sound';

import { 
    BaseScene,
} from './BaseScene';
import { sceneManager } from '../SceneManager';

import {
    CARD_BASE_1,
    CARD_BASE_2,
    CARD_BASE_OUTLINE,
    CARD_BASE,
    CARD_ELEMENT_BASE,
    BGM_BATTLE,
    SE_BATTLE_START,
    SE_ATTACK,
    SE_CARD_MOVE,
    SE_CARD_PUT,
    IMG_SHURIKEN_BASE,
    BATTLE_SHEET,
} from '../CommonAssets';

import {
    SCREEN_WIDTH,
    SCREEN_HEIGHT,
    FONT_1,
} from '../GameConst';

import {
    BATTLE_BOARD_POS,
} from '../BattleConst';
import { BattleManager, BATTLE_STATE, EVENT, TURN_STATE } from './BattleScene/BattleManager';
import { CardObject } from '../components/CardObject';
import { NpcManager } from './BattleScene/NpcManager';
import { HomeScene } from './HomeScene';
import { ShurikenObject } from './BattleScene/ShurikenObject';
import { Tween24, Ease24 } from 'tween24';
import { getAPI, postAPI } from '../utils/API';
import { userDataManager } from '../utils/UserDataManager';

export const BATTLE_BG = 'battle_bg';

const HOST_PLAYER_ID = 1;
const NPC_PLAYER_ID = 2;

export class BattleScene extends BaseScene {
    resources(){
        return [
            [BATTLE_BG, 'img/battle_bg.png'],
            [CARD_BASE.name, CARD_BASE.path],
            [CARD_ELEMENT_BASE.name, CARD_ELEMENT_BASE.path],
            [CARD_BASE_1.name, CARD_BASE_1.path],
            [CARD_BASE_2.name, CARD_BASE_2.path],
            [CARD_BASE_OUTLINE.name, CARD_BASE_OUTLINE.path],
            [BGM_BATTLE.name, BGM_BATTLE.path],
            [SE_BATTLE_START.name, SE_BATTLE_START.path],
            [SE_ATTACK.name, SE_ATTACK.path],
            [SE_CARD_MOVE.name, SE_CARD_MOVE.path],
            [SE_CARD_PUT.name, SE_CARD_PUT.path],
            [IMG_SHURIKEN_BASE.name, IMG_SHURIKEN_BASE.path],
            [BATTLE_SHEET.name, BATTLE_SHEET.path],
        ];
    }
    async Init(floorData){
        this.floorData = floorData;
        const backgroundSprite = new Sprite(Assets.get(BATTLE_SHEET.background));
        this.addChild(backgroundSprite);

        //盤面UI作成
        this.setBoard();

        this.cardLayer = new Container();
        this.addChild(this.cardLayer);
        this.shurikenLayer = new Container();
        this.addChild(this.shurikenLayer);

        this.cpuData = await getAPI(`/towers/floors/${floorData.id}/cpu`);

        this.battleManager = new BattleManager(HOST_PLAYER_ID, NPC_PLAYER_ID, this.cpuData);
        this.changeBattleStateEventBind = this.changeBattleStateEvent.bind(this);
        this.changeTurnStateEventBind = this.changeTurnStateEvent.bind(this);
        this.putCardEventBind = this.putCardEvent.bind(this);
        this.battleManager.event.on(EVENT.CHANGE_BATTLE_STATE, this.changeBattleStateEvent.bind(this));
        this.battleManager.event.on(EVENT.CHANGE_TURN_STATE, this.changeTurnStateEvent.bind(this));
        this.battleManager.event.on(EVENT.PUT_CARD, this.putCardEvent.bind(this));

        this.enemyManager = new NpcManager(this.battleManager, NPC_PLAYER_ID, this.cpuData);

        this.yourHandObjects = new Map();
        this.enemyHandObjects = new Map();
        this.selectHandIndex = -1;
        this.selectBoardIndex = -1;
        this.rotateCardCount = 0;

        this.infoText = new Text('', {
            fontFamily: FONT_1,
            fontSize: 50,
            fill: 'white',
        });
        this.addChild(this.infoText);
        this.setInfoText('バトル準備');

        this.buttonTurnEnd = new Sprite(Assets.get(BATTLE_SHEET.oku));
        this.buttonTurnEnd.anchor.set(0.5);
        this.addChild(this.buttonTurnEnd);
        this.buttonTurnEnd.y = SCREEN_HEIGHT * 0.73;
        this.buttonTurnEnd.x = SCREEN_WIDTH * 0.5;
        this.buttonTurnEnd.eventMode = 'static';
        this.buttonTurnEnd.on('pointerdown', () => {
            if(this.selectHandIndex == -1) return;
            if(this.selectBoardIndex == -1) return;
            const card = this.yourHandObjects.get(this.selectHandIndex);
            card.cardData.setRotateCount(this.rotateCardCount);
            this.battleManager.PutCard(HOST_PLAYER_ID, this.selectBoardIndex, this.selectHandIndex, this.rotateCardCount);
            this.selectHandIndex = -1;
            this.selectBoardIndex = -1;
            this.rotateCardCount = 0;
        });
        this.buttonTurnEnd.visible = false;

        this.enemyPointText = new Text('', {
            fontFamily: FONT_1,
            fontSize: 40,
            fill: 'white',
        });
        this.addChild(this.enemyPointText);
        this.enemyPointText.x = 10;
        this.enemyPointText.y = 10;

        this.yourPointText = new Text('', {
            fontFamily: FONT_1,
            fontSize: 40,
            fill: 'white',
        });
        this.addChild(this.yourPointText);
        this.yourPointText.x = 10;
        this.yourPointText.y = SCREEN_HEIGHT - 10 - this.yourPointText.height;

        this.setResultText();

    }

    setInfoText(text){
        this.infoText.text = text;
        this.infoText.x = SCREEN_WIDTH * 0.5 - this.infoText.width * 0.5;
        this.infoText.y = SCREEN_HEIGHT * 0.25 - this.infoText.height * 0.5;
    }

    setBoard(){
        const cardPositionSprite = new Sprite(Assets.get(BATTLE_SHEET.okiba));
        cardPositionSprite.anchor.set(0.5);
        cardPositionSprite.y = SCREEN_HEIGHT * 0.5;
        cardPositionSprite.x = SCREEN_WIDTH * 0.5;
        this.addChild(cardPositionSprite);

        const coinPositionSprite = new Sprite(Assets.get(BATTLE_SHEET.coin_haichi));
        coinPositionSprite.anchor.set(0.5);
        coinPositionSprite.y = SCREEN_HEIGHT * 0.5;
        coinPositionSprite.x = SCREEN_WIDTH * 0.5;
        this.addChild(coinPositionSprite);

        
        const yourNameAreaSprite = new Sprite(Assets.get(BATTLE_SHEET.jibun));
        yourNameAreaSprite.y = SCREEN_HEIGHT * 0.795;
        this.addChild(yourNameAreaSprite);

        const yourHandAreaSprite = new Sprite(Assets.get(BATTLE_SHEET.hudaokiba_01));
        yourHandAreaSprite.anchor.set(0.5);
        yourHandAreaSprite.y = SCREEN_HEIGHT * 0.88;
        yourHandAreaSprite.x = SCREEN_WIDTH * 0.5;
        const yourHandPositionSprite = new Sprite(Assets.get(BATTLE_SHEET.temochi));
        yourHandPositionSprite.anchor.set(0.5);
        yourHandAreaSprite.addChild(yourHandPositionSprite);
        this.addChild(yourHandAreaSprite);

        const enemyNameAreaSprite = new Sprite(Assets.get(BATTLE_SHEET.teki));
        enemyNameAreaSprite.anchor.set(1, 0);
        enemyNameAreaSprite.x = SCREEN_WIDTH;
        enemyNameAreaSprite.y = SCREEN_HEIGHT * 0.174;
        this.addChild(enemyNameAreaSprite);

        const enemyHandAreaSprite = new Sprite(Assets.get(BATTLE_SHEET.hudaokiba_02));
        enemyHandAreaSprite.anchor.set(0.5);
        enemyHandAreaSprite.y = SCREEN_HEIGHT * 0.12;
        enemyHandAreaSprite.x = SCREEN_WIDTH * 0.5;
        const enemyHandPositionSprite = new Sprite(Assets.get(BATTLE_SHEET.temochi));
        enemyHandPositionSprite.anchor.set(0.5);
        enemyHandAreaSprite.addChild(enemyHandPositionSprite);
        this.addChild(enemyHandAreaSprite);

        // タッチ判定用オブジェクト生成
        for(let i = 0; i < 8; i++)
        {
            const circle = new Graphics();
            circle.beginFill(0xDE3249, 1);
            circle.drawCircle(BATTLE_BOARD_POS[i].x, BATTLE_BOARD_POS[i].y, 150);
            circle.endFill();
            circle.eventMode = 'static';
            circle.on('pointerdown', () => {
                this.selectBoard(i);
            });
            circle.alpha = 0; // この行をコメントアウトするとタッチ判定が可視化できる
            this.addChild(circle);
        }
    }

    selectBoard(boardIndex){
        if(this.selectHandIndex == -1) return;
        if(this.selectBoardIndex == boardIndex) {
            // 回転パターン
            this.rotateCardCount++;
            if(4 < this.rotateCardCount){
                this.rotateCardCount = 0;
            }
        }
        const card = this.yourHandObjects.get(this.selectHandIndex);
        this.putCardObBord(card, boardIndex, this.rotateCardCount);
        this.selectBoardIndex = boardIndex;
        sound.play(SE_CARD_MOVE.name);
    }

    putCardObBord(cardObject, boardIndex, rotateCount)
    {
        cardObject.scale.set(0.75);
        cardObject.x = BATTLE_BOARD_POS[boardIndex].x;
        cardObject.y = BATTLE_BOARD_POS[boardIndex].y;
        cardObject.rotation = BATTLE_BOARD_POS[boardIndex].angle * Math.PI / 180 +  rotateCount * 72 * Math.PI / 180;
    }

    changeBattleStateEvent(state){
        let resultText = '';
        switch(state){
        case BATTLE_STATE.START_BATTLE:
            sound.play(SE_BATTLE_START.name);
            this.setInfoText('バトル開始');
            this.showHands();
            this.battleManager.Ready(true);
            break;
        case BATTLE_STATE.IN_BATTLE:
            setTimeout(() => {
                sceneManager.setBGM(BGM_BATTLE.name, true);
            }, 2000);
            break;
        case BATTLE_STATE.BATTLE_SHURIKEN_RESULT:
            this.setInfoText('手裏剣判定');
            this.setResultText();
            if(this.battleManager.useShurikenPlayerId != 0)
            {
                this.shurikenObject = HOST_PLAYER_ID == this.battleManager.useShurikenPlayerId ? this.yourShurikenObject : this.enemyShurikenObject;
                this.shurikenObject.onRotate();
                Tween24.tween(this.shurikenObject, 0.5, Ease24._BackOutWith(3)).x(SCREEN_WIDTH * 0.5).play();
                Tween24.tween(this.shurikenObject, 0.5, Ease24._BackOutWith(10)).y(SCREEN_HEIGHT * 0.5).play();
                sound.play(SE_ATTACK.name);                
            }
            break;
        case BATTLE_STATE.BATTLE_RESULT:
            sceneManager.setBGM(null);
            this.setResultText(this.shurikenObject);
            if(this.winScored == 0)
            {
                resultText = '引分';
            }
            else if(0 < this.winScored)
            {
                resultText = '勝利';
            }
            else
            {
                resultText = '敗北';
            }
            this.setInfoText(resultText);
            sound.play(SE_BATTLE_START.name);
            break;
        case BATTLE_STATE.END_BATTLE:
            if(this.winScored == 0)
            {
                resultText = '引分';
            }
            else if(0 < this.winScored)
            {
                resultText = '勝利';
                this.sendScore();
            }
            else
            {
                resultText = '敗北';
            }
            this.setInfoText(resultText + '(タップで戻る)');
            this.eventMode = 'static';
            this.once('pointerdown', () => {
                sceneManager.LoadScene(HomeScene);
            });
            break;
        }
    }

    async sendScore()
    {
        const result = await postAPI(`/towers/floors/${this.floorData.id}/score`, [
            ['score', this.winScored],
        ]);
        if(!result){
            console.error('ERROR');
            return;
        }
        userDataManager.updateUserData(result);
        console.log(result);
    }

    setResultText(shurikenObject)
    {
        const yourYaku = this.battleManager.getResult(HOST_PLAYER_ID, shurikenObject);
        const enemyYaku = this.battleManager.getResult(NPC_PLAYER_ID, shurikenObject);
        const yourText = `勝点:${yourYaku.katiTen} 役点:${yourYaku.yakuTen} ( 三枚:${yourYaku.mai3} 三色:${yourYaku.iro3} 三数:${yourYaku.kazu3} 二色:${yourYaku.iro2} 二数:${yourYaku.kazu2} )`;
        const enemyText = `勝点:${enemyYaku.katiTen} 役点:${enemyYaku.yakuTen} ( 三枚:${enemyYaku.mai3} 三色:${enemyYaku.iro3} 三数:${enemyYaku.kazu3} 二色:${enemyYaku.iro2} 二数:${enemyYaku.kazu2} )`;
        if(!shurikenObject){
            this.yourPointText.text = yourText;
            this.enemyPointText.text = enemyText;
        }
        else
        {
            // TODO: これはモック用仮実装。手裏剣ありの結果は別でテキスト出す
            const enemyPointText = new Text(enemyText, {
                fontFamily: FONT_1,
                fontSize: 40,
                fill: 'yellow',
            });
            this.addChild(enemyPointText);
            enemyPointText.x = 10;
            enemyPointText.y = 60;
    
            const yourPointText = new Text(yourText, {
                fontFamily: FONT_1,
                fontSize: 40,
                fill: 'yellow',
            });
            this.addChild(yourPointText);
            yourPointText.x = 10;
            yourPointText.y = SCREEN_HEIGHT - 60 - yourPointText.height;
        }
        this.winScored = (yourYaku.katiTen + yourYaku.yakuTen) - (enemyYaku.katiTen + enemyYaku.yakuTen);
    }

    changeTurnStateEvent(state){
        switch(state){
        case TURN_STATE.HOST_START:
            this.setInfoText('あなたのターン');
            this.buttonTurnEnd.visible = true;
            break;
        case TURN_STATE.HOST_END:
            this.buttonTurnEnd.visible = false;
            break;
        case TURN_STATE.GUEST_START:
            this.setInfoText('相手のターン');
            break;
        case TURN_STATE.BATTLE_EFFECT:
            this.setResultText();
            break;
        }
    }

    putCardEvent(playerId, boardIndex, cardIndex, rotateCount){
        const isSelf = HOST_PLAYER_ID == playerId;
        var cardObject = null;
        if(isSelf)
        {
            cardObject = this.yourHandObjects.get(cardIndex);
            this.yourHandObjects.delete(cardIndex);
            // 選択状態を解除
            cardObject.select(false);
            cardObject.eventMode = 'none';
        }
        else
        {
            cardObject = this.enemyHandObjects.get(cardIndex);
            this.enemyHandObjects.delete(cardIndex);
        }

        this.putCardObBord(cardObject, boardIndex, rotateCount);
        sound.play(SE_CARD_PUT.name);
    }

    showHands(){
        for(let i = 0; i < 5; i++){
            const card = new CardObject(true, this.battleManager.hostHands.get(i));
            card.scale.set(0.45);
            this.cardLayer.addChild(card);
            card.y = SCREEN_HEIGHT - card.height - 65;
            card.x = i * card.width + card.width * 0.5 + 145;
            this.yourHandObjects.set(i, card);
            // 自分の手札にはタッチ時の処理を仕込む
            card.eventMode = 'static';
            card.on('pointerdown', () => {
                this.selectHand(i);
            });
        }

        for(let i = 0; i < 5; i++){
            const card = new CardObject(false, this.battleManager.guestHands.get(i));
            card.scale.set(0.45);
            this.cardLayer.addChild(card);
            card.y = card.height + 80;
            card.x = SCREEN_WIDTH - (i * card.width + card.width * 0.5 + 145);
            this.enemyHandObjects.set(i, card);
        }
        this.shurikenObject = null;

        this.yourShurikenObject = new ShurikenObject(HOST_PLAYER_ID, userDataManager.getDeckShurikenData(1));
        this.shurikenLayer.addChild(this.yourShurikenObject);
        this.yourShurikenObject.x = SCREEN_WIDTH * 0.82;
        this.yourShurikenObject.y = SCREEN_HEIGHT * 0.75;
        this.enemyShurikenObject = new ShurikenObject(NPC_PLAYER_ID, this.cpuData.shuriken);
        this.shurikenLayer.addChild(this.enemyShurikenObject);
        this.enemyShurikenObject.x = SCREEN_WIDTH * 0.18;
        this.enemyShurikenObject.y = SCREEN_HEIGHT * 0.25;
    }

    selectHand(index){
        if(this.battleManager.turnState != TURN_STATE.HOST_START) return;
        if(this.selectHandIndex != -1)
        {
            const oldCard = this.yourHandObjects.get(this.selectHandIndex);
            oldCard.select(false);
            oldCard.eventMode = 'static';
            this.backHand(this.selectHandIndex);
        }
        if(index != -1)
        {
            const newCard = this.yourHandObjects.get(index);
            newCard.select(true);
            newCard.eventMode = 'none';
        }
        this.selectHandIndex = index;
        this.selectBoardIndex = -1;
        this.rotateCardCount = 0;
        sound.play(SE_CARD_MOVE.name);
    }

    backHand(index){
        const card = this.yourHandObjects.get(index);
        card.scale.set(0.45);
        card.y = SCREEN_HEIGHT - card.height - 65;
        card.x = index * card.width + card.width * 0.5 + 145;
        card.rotation = 0;
    }

    UpdateScene(dt){
        this.battleManager.Update(dt);
    }
}
